export default {
  namespaced: true,

  state: () => ({
    value: false
  }),

  getters: {
    value: state => state.value,
  },

  mutations: {
    set(state, val) {
      state.value = val
    }
  }
}